import * as React from 'react';

const salesSmall = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="20" height="20" rx="4" fill="white" />
    <path
      d="M11.1428 2.76264C11.1428 2.58303 11.2452 2.41913 11.4067 2.34038L14.3654 0.896894C14.4954 0.833463 14.6474 0.833462 14.7774 0.896894L17.7361 2.34038C17.8976 2.41913 18 2.58303 18 2.76264V18.1551C18 18.4146 17.7896 18.625 17.5301 18.625H11.6127C11.3532 18.625 11.1428 18.4146 11.1428 18.1551V2.76264Z"
      fill="url(#paint0_linear_23086_12531)"
    />
    <g style={{ mixBlendMode: 'multiply' }}>
      <path
        d="M2 9.14116L5.2 8.11035L8.4 9.14116V18.6246H2V9.14116Z"
        fill="url(#paint1_linear_23086_12531)"
      />
    </g>
    <g style={{ mixBlendMode: 'multiply' }}>
      <path
        d="M6.57129 6.15119C6.57129 5.96405 6.68235 5.79475 6.85401 5.72022L9.58417 4.53485C9.70353 4.48303 9.83904 4.48303 9.95841 4.53485L12.6886 5.72022C12.8602 5.79475 12.9713 5.96405 12.9713 6.15119V18.1552C12.9713 18.4147 12.7609 18.625 12.5014 18.625H7.04113C6.78164 18.625 6.57129 18.4147 6.57129 18.1552V6.15119Z"
        fill="url(#paint2_linear_23086_12531)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_23086_12531"
        x1="16.9206"
        y1="15.8927"
        x2="7.4833"
        y2="14.4739"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2744FF" />
        <stop offset="1" stopColor="#B9D5FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_23086_12531"
        x1="5.39941"
        y1="10.7389"
        x2="12.1456"
        y2="19.9782"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7DC4FF" />
        <stop offset="1" stopColor="#FFE7AB" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_23086_12531"
        x1="11.2772"
        y1="14.9135"
        x2="0.725917"
        y2="12.022"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BDD1E7" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
);

export default salesSmall;